<template>
  <div class="chat">
    <!-- {{formParamSRSt}} -->
    <!-- {{formParamSRSt.interactive_message_type}} -->
    <!-- {{linkRows}} -->
    <div class="chat-box">
      <div class="chats">
        <div class="chat chat-right">
          <div class="chat-body">
            <div class="chat-bubble">
              <div class="chat-content">
                <div
                  class="chat-img-group clearfix"
                  v-if="formParamSRSt.message.message_type=='image' && formParamSRSt.interactive_message_type!='list_text'"
                >
                  <a class="chat-img-attach" href="javascript:void(0)">
                    <img style="max-height:200px" alt :src="formParamSRSt.message.file_url" />
                  </a>
                </div>
                <ul
                  class="attach-list"
                  v-if="formParamSRSt.message.message_type=='document' && formParamSRSt.interactive_message_type!='list_text'"
                >
                  <li>
                    <i class="fa fa-file"></i>
                    <a :href="formParamSRSt.message.file_url" target="_blank">File</a>
                  </li>
                </ul>
                <p
                  v-html="messageFilter(formParamSRSt.message.text)"
                  v-if="formParamSRSt.message.text!=''"
                  v-linkified
                ></p>
                <span
                  v-html="formParamSRSt.footer_message"
                  class="text-muted"
                  style="font-size:10px;"
                  v-linkified
                  v-if="formParamSRSt.footer_message_status==true && formParamSRSt.interactive_message_status==true"
                ></span>
                <template
                  v-if="formParamSRSt.buttons.length && formParamSRSt.interactive_message_status==true"
                >
                  <div v-if="formParamSRSt.interactive_message_type=='button_text'">
                    <div
                      class="text-center"
                      v-for="(auto_reply_button_id,idx) in formParamSRSt.buttons"
                      :key="idx"
                    >
                      <div class="user-add-shedule-list" v-if="auto_reply_button_id!=''">
                        <a href="javascript:void(0)">
                          <i class="fa fa-tags"></i>
                          {{getButtonLabelById(auto_reply_button_id)}}
                        </a>
                      </div>
                    </div>
                  </div>
                  <div v-if="formParamSRSt.interactive_message_type=='list_text'">
                    <table class="table table-nowrap">
                      <template v-for="(auto_reply_button_id,idx) in formParamSRSt.buttons">
                        <tr v-if="auto_reply_button_id!=''" :key="idx">
                          <td>
                            <label
                              :for="auto_reply_button_id"
                            >{{getButtonLabelById(auto_reply_button_id)}}</label>
                          </td>
                          <td>
                            &nbsp;
                            <input
                              disabled
                              name="radio_list_text"
                              class="form-check-input"
                              :id="auto_reply_button_id"
                              type="radio"
                            />
                          </td>
                        </tr>
                      </template>
                    </table>
                  </div>
                  <div v-if="formParamSRSt.interactive_message_type=='action_link'">
                    <div
                      class="text-center"
                      v-for="(auto_reply_button_id,idx) in formParamSRSt.buttons"
                      :key="idx"
                    >
                      <div class="user-add-shedule-list" v-if="auto_reply_button_id!=''">
                        <a
                          href="javascript:void(0)"
                          v-html="getLinkLabelById(auto_reply_button_id)"
                        ></a>
                      </div>
                    </div>
                  </div>
                </template>
              </div>

              <div
                class="chat-content"
                v-if="(formParamSRSt.message.message_type=='image' || formParamSRSt.message.message_type=='document') && formParamSRSt.interactive_message_type=='list_text'"
              >
                <div
                  class="chat-img-group clearfix"
                  v-if="formParamSRSt.message.message_type=='image' "
                >
                  <a class="chat-img-attach" href="javascript:void(0)">
                    <img style="max-height:200px" alt :src="formParamSRSt.message.file_url" />
                  </a>
                </div>
                <ul class="attach-list" v-if="formParamSRSt.message.message_type=='document'">
                  <li>
                    <i class="fa fa-file"></i>
                    <a :href="formParamSRSt.message.file_url" target="_blank">File</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    buttonsRows: {
      type: Array,
      default: () => [{ button_text: "" }]
    },
    linkRows: {
      type: Array
    }
  },
  data() {
    return {
      isLoading: false
    };
  },
  watch: {},
  computed: {
    formParamSRSt() {
      return this.$store.state.omniwa.broadcastParamSt;
    }
  },
  methods: {
    getButtonLabelById(id) {
      let arr = this.buttonsRows.find(msgs => msgs.id === id);
      if (arr != null && typeof arr.button_text != "undefined") {
        return arr.button_text;
      } else {
        return "";
      }
    },
    getLinkLabelById(id) {
      let arr = this.linkRows.find(msgs => msgs.id === id);
      if (arr != null && typeof arr.button_text != "undefined") {
        if (arr.button_type == "call") {
          return '<i class="fa fa-phone"></i> ' + arr.button_text;
        } else {
          return '<i class="fa fa-external-link"></i> ' + arr.button_text;
        }
      } else {
        return "";
      }
    },
    messageFilter(message) {
      return message.replace(/\r?\n/g, "<br />");
    }
  },
  async created() {},
  beforeDestroy() {},
  mounted() {
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "buttons-add"
};
</script>


// WEBPACK FOOTER //
// src/views/messageReport/preview.vue